import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import {makeStyles} from '@material-ui/core/styles';
import {setErrorInformation} from "../../redux/application";
import {Form} from "react-final-form";
import Grid from "@material-ui/core/Grid";
import TextField from '../adapters/TextField';
import Button from '../adapters/Button';
import {history} from "../../App";
import {DEFAULT_PAGE} from "../../constants/app-constants";
import {resetPassword} from '../../redux/user';


const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    form: {
      width: '100%'
    }
  })
);


export default function ChangePassword(props) {

  const dispatch = useDispatch();

  useEffect(() => {
    const activationCode = window.location?.hash?.substring(1);
    if (!activationCode) {
      dispatch(setErrorInformation('Пустий код зміни паролю'));
    }
  }, []);

  async function submit(values) {
    await(dispatch(resetPassword({resetCode: window.location?.hash?.substring(1), newPassword: values.password})))
}

  function validate(values) {
    let errors = {};
    if (!values.password)
      errors.password = 'Необхідно заповнити поле "Пароль"';
    if (values.password && values.password.length < 6)
      errors.password = 'Довжина паролю має бути не менше 6 символів';
    if (values.password && values.password != values.passwordRepeat)
      errors.passwordRepeat = 'Введені паролі не співпадають';
    return errors;
  }

  const classes = useStyles();

  return (<Form
    onSubmit={submit}
    validate={validate}
    render={({handleSubmit, hasValidationErrors}) => {
      submit = handleSubmit;
      return (
        <Container component="main" maxWidth="xs">
          <div className={classes.paper}>
            <form className={classes.form} onSubmit={handleSubmit} noValidate>
              <Typography variant="h4" noWrap>
                Зміна паролю
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField name="password" type="password" label="Пароль" required/>
                </Grid>
                <Grid item xs={12}>
                  <TextField name="passwordRepeat" type="password" label="Підтвердження паролю" required/>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Button type="submit" variant="contained" color="primary" fullWidth
                          disabled={hasValidationErrors}>Змінити</Button>
                </Grid>
                <Grid item xs={6}>
                  <Button variant="contained" color="primary" fullWidth
                          onClick={() => history.push(DEFAULT_PAGE)}>Відмінити</Button>
                </Grid>
              </Grid>
            </form>
          </div>
        </Container>
      )
    }}
  />);
}

